export default __webpack_public_path__ + "static/media/icon-logout.b5b56198.svg";